<template>
	<div id="app" class="fullSize">

		<Privacy v-bind:App="app" 
		v-if="app.privacyPageDisplay" />

		<CookiesDisclamer v-bind:App="app" 
		v-if="app.cookiesPageDisplay" />

		<CookiesInfo v-bind:App="app"
		v-if="app.cookiesPopupDisplay && false" />

		

		<BeginForm v-bind:App="app" 
		v-if="!app.beginFormCompleted"/>

		<VideoPlayer v-bind:App="app" 
		v-bind:class="app.video.display ? 'opened' : 'hidden'"/>

		<Help v-bind:App="app" />

		<a id="logo" href="#neurovascular"></a>

		<button id="fullscreen" v-on:click="app.requestFullScreen()"></button>

		<Loading v-bind:App="app" />
		<div id="StartWrapper" class="fullSize touch" v-if="!started" v-on:click="start()">
			{{ app.lang.get('Click to start') }}
		</div>
		<UI v-bind:App="app" />


		<RenderScene v-bind:App="app" />
	</div>
</template>

<script>
import App from './App.js'
import Loading from './components/Loading.vue'
import RenderScene from './components/RenderScene.vue'
import UI from './components/UI.vue'
import Help from './components/Help.vue'
import BeginForm from './components/BeginForm.vue'
import Privacy from './components/Privacy.vue'
import CookiesDisclamer from './components/CookiesDisclamer.vue'
import CookiesInfo from './components/CookiesInfo.vue'

import VideoPlayer from './components/VideoPlayer.vue'


export default {
	name: 'App',
	components: {
		RenderScene,
		UI,
		Loading,
		Help,
		BeginForm,
		VideoPlayer,
		Privacy,
		CookiesDisclamer,
		CookiesInfo
	},
	data : function() {
		return {
			app: new App(),
			started: false
			
		}
	},
	mounted() {

		// Removes the hash if any at the beginning (reloading means restart at the beginning)
		//location.hash = ''

		this.app.startHash = location.hash;
		console.log('startHash', this.app.startHash)
		history.pushState("#ddd", document.title, window.location.pathname + window.location.search);

		window.addEventListener("hashchange",() => {
			document.dispatchEvent(this.app.events.hashChanged)
		}, false);

		

	},
	created() {

	},
	methods : {
		start() {
			this.started = true;
			
				document.dispatchEvent(this.app.events.playVideo);
			
			
			document.body.classList.remove("notready");
		}
	}
}
</script>

<style src="./assets/css/_fonts.css"></style>
<style src="./assets/css/main.css"></style>
